import { lazy } from "react";

// Metadata is kept separate from the article body components (see
// ARTICLE_CONTENT_LOADERS below) on purpose: anything that only needs to
// render a title/excerpt card (e.g. RelatedArticles) can import this file
// without pulling in every article's full JSX body into its bundle.
export const ARTICLES_META = [
  {
    slug: "szemelyi-kolcson-teljes-utmutato",
    title: "Személyi kölcsön 2026: Teljes útmutató kezdőknek",
    metaDescription:
      "Mi a személyi kölcsön, milyen típusai vannak, és mire figyelj a THM-nél és a jövedelemvizsgálatnál? Átfogó útmutató kezdőknek, 2026-os szemlélettel.",
    category: "szemelyi-kolcson",
    schemaType: "Article",
    publishedAt: "2026-08-03",
    excerpt:
      "Egy helyen minden alapfogalom: típusok, THM, jövedelemvizsgálat és a legfontosabb buktatók, mielőtt belevágnál.",
  },
  {
    slug: "szabad-felhasznalasu-vs-hitelkivalto-kolcson",
    title:
      "Szabad felhasználású vs. hitelkiváltó személyi kölcsön: mi a különbség?",
    metaDescription:
      "Szabad felhasználású vagy hitelkiváltó személyi kölcsön illik hozzád? Bemutatjuk a két konstrukció közti különbséget, előnyöket és hátrányokat egyaránt.",
    category: "szemelyi-kolcson",
    schemaType: "Article",
    publishedAt: "2026-08-09",
    excerpt:
      "Két konstrukció, két teljesen más célra — segítünk eldönteni, melyik illik a te helyzetedhez.",
  },
  {
    slug: "mennyi-szemelyi-kolcsont-kaphatok",
    title:
      "Mennyi személyi kölcsönt kaphatok? Jövedelemvizsgálat és JTM-mutató magyarázata",
    metaDescription:
      "Mekkora személyi kölcsönt kaphatsz a jövedelmed alapján? A JTM-mutató és a jövedelemvizsgálat logikáját magyarázzuk el, számítási példával együtt.",
    category: "szemelyi-kolcson",
    schemaType: "Article",
    publishedAt: "2026-08-14",
    excerpt:
      "A bank ugyanígy számol: nézd meg, hogyan határozza meg a jövedelmed a felvehető hitelösszeget.",
  },
  {
    slug: "szemelyi-kolcson-khr-listaval",
    title: "Személyi kölcsön KHR-listával: van megoldás?",
    metaDescription:
      "Igényelhető-e személyi kölcsön KHR-listás múlttal? Az aktív és passzív KHR-státusz különbségét és a lehetséges megoldásokat mutatjuk be röviden.",
    category: "szemelyi-kolcson",
    schemaType: "FAQPage",
    publishedAt: "2026-08-17",
    excerpt:
      "KHR-bejegyzéssel sem feltétlenül reménytelen a helyzet — megmutatjuk, mikor van esély a jóváhagyásra.",
  },
  {
    slug: "legjobb-szemelyi-kolcson-valasztasa",
    title:
      "Hogyan válaszd ki a legjobb személyi kölcsönt? THM-összehasonlítás lépésről lépésre",
    metaDescription:
      "Nem a reklámozott kamat számít, hanem a THM. Lépésről lépésre bemutatjuk, hogyan hasonlítsd össze a személyi kölcsön ajánlatokat döntés előtt.",
    category: "szemelyi-kolcson",
    schemaType: "HowTo",
    publishedAt: "2026-08-20",
    excerpt:
      "A hirdetett kamat becsaphat — ez a lépésről lépésre útmutató megmutatja, mit nézz meg helyette.",
  },
  {
    slug: "szemelyi-kolcson-igenyles-menete",
    title:
      "Személyi kölcsön igénylése online: dokumentumok és a teljes folyamat lépésről lépésre",
    metaDescription:
      "Milyen dokumentumok kellenek a személyi kölcsön igényléséhez, és hogyan zajlik online a folyamat? Lépésről lépésre, az összehasonlítástól a folyósításig.",
    category: "szemelyi-kolcson",
    schemaType: "HowTo",
    publishedAt: "2026-08-23",
    excerpt:
      "Az összehasonlítástól a folyósításig: így néz ki a teljes online igénylési folyamat a gyakorlatban.",
  },
];

// Six explicit React.lazy() calls with static string literal import paths —
// required so webpack can code-split each article body into its own chunk.
// Deliberately not built from a loop over ARTICLES_META: a dynamic
// `import(variable)` defeats static analysis and either bundles everything
// together or breaks code-splitting entirely.
export const ARTICLE_CONTENT_LOADERS = {
  "szemelyi-kolcson-teljes-utmutato": lazy(() =>
    import("./szemelyi-kolcson-teljes-utmutato")
  ),
  "szabad-felhasznalasu-vs-hitelkivalto-kolcson": lazy(() =>
    import("./szabad-felhasznalasu-vs-hitelkivalto-kolcson")
  ),
  "mennyi-szemelyi-kolcsont-kaphatok": lazy(() =>
    import("./mennyi-szemelyi-kolcsont-kaphatok")
  ),
  "szemelyi-kolcson-khr-listaval": lazy(() =>
    import("./szemelyi-kolcson-khr-listaval")
  ),
  "legjobb-szemelyi-kolcson-valasztasa": lazy(() =>
    import("./legjobb-szemelyi-kolcson-valasztasa")
  ),
  "szemelyi-kolcson-igenyles-menete": lazy(() =>
    import("./szemelyi-kolcson-igenyles-menete")
  ),
};

/**
 * @param {string} slug
 * @returns {object|null}
 */
export function getArticleMeta(slug) {
  return ARTICLES_META.find((article) => article.slug === slug) || null;
}

/**
 * @param {string} category
 * @param {string} excludeSlug
 * @param {number} [limit]
 * @returns {object[]}
 */
export function getRelatedArticlesMeta(category, excludeSlug, limit = 4) {
  return ARTICLES_META.filter(
    (article) => article.category === category && article.slug !== excludeSlug
  )
    .sort((a, b) => (a.publishedAt < b.publishedAt ? 1 : -1))
    .slice(0, limit);
}
